import { ICasino } from 'constants/types';
import { useQuery } from 'hooks/useQuery';
import {
  CasinoListParams,
  getCasinoById,
  getCasinosBySlot,
  listCasinos,
} from 'lib/api/casinos';
import { PaginationResponse } from 'lib/api/types';
import { HookQueryOptions, queryKey } from './shared';

interface CasinoBySlotRequest {
  id: string;
  countries?: string | null;
}

export const useCasinosQuery = (
  payload: CasinoListParams = {},
  options?: HookQueryOptions
) =>
  useQuery(queryKey('casino.list', payload), () => listCasinos(payload), {
    skip: options?.skip,
    deps: [payload.collections, payload.countries, payload.page, payload.limit],
  });

export const useCasinoByIdQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery<ICasino | null>(
    queryKey('casino.byId', payload),
    () => getCasinoById(payload?.id),
    { skip: options?.skip || !payload?.id }
  );

export const useCasinosBySlotQuery = (
  payload: CasinoBySlotRequest,
  options?: HookQueryOptions
) =>
  useQuery<PaginationResponse<ICasino>>(
    queryKey('casino.bySlot', payload),
    () => getCasinosBySlot(payload.id, payload.countries),
    { skip: options?.skip || !payload?.id }
  );
